import { useAuthContext } from '@inbox-demo-nx/contexts';
import { useMainAppWindowMessageHandler } from '@inbox-demo-nx/utils-web-demo-message-handler';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useDripsyTheme } from 'dripsy';
import { lazy, Suspense } from 'react';

import HomeScreen from './HomeScreen';
import InboxScreen from './InboxScreen';
import SettingScreen from './SettingScreen';

const ChatScreen = lazy(() => import('./ChatScreen'));

const Stack = createNativeStackNavigator();

export default function RootScreen() {
  const { currentUser } = useAuthContext();
  const { theme } = useDripsyTheme();

  const isSignedIn = !!currentUser;
  useMainAppWindowMessageHandler();

  if (!isSignedIn) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <NavigationContainer>
        <Stack.Navigator
          screenOptions={{
            headerTintColor: theme.colors.navigationTintColor,
            headerTitleStyle: { color: theme.colors.text },
          }}
        >
          <Stack.Screen
            name="Home"
            component={HomeScreen}
            options={{ headerShown: false }}
          />
          <Stack.Screen name="Settings" component={SettingScreen} />
          <Stack.Screen name="Inbox" component={InboxScreen} />
          <Stack.Screen name="Chat" component={ChatScreen} />
        </Stack.Navigator>
      </NavigationContainer>
    </Suspense>
  );
}
